export function displayValue(value?: string | null): string {
  const normalized = value?.trim()
  return normalized || '—'
}

export function formatChatDate(value?: string | null): string {
  const normalized = value?.trim()
  if (!normalized) return '—'

  const date = new Date(normalized)
  if (Number.isNaN(date.getTime())) return normalized

  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date)
}

/** Para birimi eki olmadan "553,15" biçimi (döviz sütunlu gösterimlerde başlık ayrı yazılır). */
export function formatChatAmount(amount: number): string {
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

/** TRY için ekranda "TL" yazılır; diğer kodlar olduğu gibi gösterilir. */
export function getChatCurrencyLabel(currency: 'TRY' | 'USD' | 'EUR'): string {
  return currency === 'TRY' ? 'TL' : currency
}

/** "553,15 TL" / "1,42 USD" biçimi (ekrandaki bakiye/borç kartlarıyla aynı gösterim). */
export function formatChatMoney(amount: number, currency: 'TRY' | 'USD' | 'EUR' = 'TRY'): string {
  return `${formatChatAmount(amount)} ${getChatCurrencyLabel(currency)}`
}

/** "%3,75" biçimi. Taksit satırları hizalansın diye ondalık hane sayısı sabit. */
export function formatChatRate(rate: number): string {
  const formatted = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(rate)
  return `%${formatted}`
}

export function getChatErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback

  const description = (error as { description?: unknown }).description
  return typeof description === 'string' && description.trim() ? description : fallback
}
